import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tab-component" }
const _hoisted_2 = {
  key: 0,
  class: "tab-headers"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "dynamic-copmponent-wrapper" }

import { ITab } from '@/types/interfaces/common.interface'
import { PropType, useSlots } from 'vue'

interface TabsEmits {
  (e: 'update:modelValue', value: string): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
  modelValue: {
    type: String,
    default: '',
  },
  tabs: {
    type: Array as PropType<ITab[]>,
    default: () => [],
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {


const emit = __emit
const slots = useSlots()

/**
 * Methods
 */
const changeTab = (tabValue: string) => {
  emit('update:modelValue', tabValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.tabs.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tab.value,
              class: _normalizeClass([{ active: tab.value === __props.modelValue }, "tab-header"]),
              onClick: ($event: any) => (changeTab(tab.value))
            }, [
              _createElementVNode("h6", null, _toDisplayString(tab.i18n ? _ctx.$t(`${tab.i18n}`) : tab.label), 1)
            ], 10, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("div", {
        key: tab.value,
        class: _normalizeClass(["tab-content", [__props.modelValue && __props.modelValue === tab.value && 'active']])
      }, [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, tab.value)
        ], 512), [
          [_vShow, _unref(slots)[tab.value] && tab.value === __props.modelValue]
        ])
      ], 2))
    }), 128))
  ]))
}
}

})